import styled from 'styled-components';

// Estilos do container principal da videochamada
export const VideoCallContainer = styled.div<{ minimized: boolean }>`
  ${({ minimized }) =>
    minimized
      ? `
    position: fixed;
    bottom: 32px;
    right: 32px;
    width: 340px;
    height: 220px;
    border-radius: 16px;
    z-index: 3000;
    padding: 12px 12px 8px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: box-shadow 0.2s;
  `
      : `
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.4);
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  `}
`;

// Estilos do conteúdo da videochamada
export const VideoCallContent = styled.div<{ minimized: boolean }>`
  ${({ minimized }) =>
    minimized
      ? `
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  `
      : `
    position: relative;
    border-radius: 16px;
    width: 90vw;
    height: 90vh;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    background: #000;
    overflow: hidden;
  `}
`;

// Botão de minimizar
export const MinimizeBtn = styled.button`
  display: flex;
  position: absolute;
  top: 32px;
  right: 32px;
  background: #fff;
  border: none;
  cursor: pointer;
  z-index: 10;
  padding: 4px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
`;

// Botão de restaurar
export const RestoreBtn = styled.button`
  display: flex;
  position: absolute;
  top: 8px;
  right: 8px;
  background: #fff;
  border: none;
  cursor: pointer;
  z-index: 10;
  padding: 4px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
`;

// Botão de fechar
export const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;

  &:hover {
    opacity: 0.8;
  }
`;

// Botão de toggle do status
export const StatusToggleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Componente minimizado do status
export const MinimizedStatusButton = styled.div`
  position: fixed;
  bottom: 15px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: #1d52a5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2000;
  border: 2px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`;

// Badge de notificação
export const NotificationBadge = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ff4444;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  animation: pulse 2s infinite;
`;

// Estilos existentes...
export const VideoRoomContainer = styled.div<{ minimized?: boolean }>`
  background: #2d2d2d;
  border-radius: 4px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  padding: ${({ minimized }) => (minimized ? '8px' : '24px 24px 64px 24px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: ${({ minimized }) => (minimized ? 'unset' : 'unset')};
  min-height: ${({ minimized }) => (minimized ? 'unset' : 'unset')};
  position: relative;
  width: ${({ minimized }) => (minimized ? '100%' : 'unset')};
  height: ${({ minimized }) => (minimized ? '100%' : '100%')};
`;

export const ErrorMessage = styled.div`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ff4d4f;
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const VideoContainer = styled.div<{ minimized?: boolean }>`
  position: relative;
  width: 100%;
  height: ${({ minimized }) => (minimized ? '220px' : '100%')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VideoWrapper = styled.div<{ minimized?: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
`;

export const Video = styled.video<{ minimized?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: ${({ minimized }) => (minimized ? '12px' : '16px')};
`;

export const LocalVideo = styled(Video)`
  transform: scaleX(-1);
`;

export const LocalVideoMini = styled(VideoWrapper)`
  position: absolute;
  width: 200px;
  height: 250px;
  bottom: -30px;
  right: 0px;
  border: 3px solid #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.18);
  z-index: 10;
  background: #222;
  border-radius: 12px;
`;

export const VideoLabel = styled.div<{ minimized?: boolean }>`
  position: absolute;
  top: ${({ minimized }) => (minimized ? '4px' : '10px')};
  left: ${({ minimized }) => (minimized ? '4px' : '10px')};
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: ${({ minimized }) => (minimized ? '2px 8px' : '4px 12px')};
  border-radius: 8px;
  font-size: ${({ minimized }) => (minimized ? '0.92rem' : '1rem')};
  font-weight: 600;
  z-index: 2;
`;

export const VideoLabelMini = styled(VideoLabel)`
  top: 8px;
  left: 8px;
  font-size: 0.95rem;
  padding: 2px 10px;
`;

export const Controls = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  padding: 1rem;
  background-color: #1a1a1a;
  border-radius: 8px;
`;

export const ControlButton = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  background-color: #333;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #444;
  }

  &:active {
    background-color: #555;
  }
`;

export const CameraControls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 16px 24px;
  border-radius: 12px;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  backdrop-filter: blur(10px);
`;

export const CameraControlButton = styled.button`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: none;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  transition: all 0.2s;
  backdrop-filter: blur(5px);

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    transform: scale(1.08);
  }

  &.end-call {
    background-color: #ff4444;
    color: #fff;
    &:hover {
      background-color: #ff6666;
    }
  }

  &.off {
    background-color: rgba(255, 0, 0, 0.3);
  }

  &.active {
    background-color: rgba(0, 255, 0, 0.3);
  }
`;

export const AcceptButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 5px;
  border: none;
  background-color: #82ac21;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  position: relative;

  &:hover {
    background-color: #00cc00;
  }
`;

export const RejectButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 5px;
  border: none;
  background-color: #ff5045;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  position: relative;

  &:hover {
    background-color: #ff6666;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const CallCard = styled.div`
  display: flex;
  gap: 8px;
  background: #ffffff;
  border: 1.5px solid #e9eaed;
  border-radius: 8px;
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  height: 62px;
`;

export const MediaQueryStyles = `
  @media (max-width: 768px) {
    ${VideoContainer} {
      grid-template-columns: 1fr;
    }

    ${CameraControls} {
      padding: 0.5rem;
    }

    ${CameraControlButton} {
      width: 35px;
      height: 35px;
    }
  }
`;

export const StatusContainer = styled.div<{ minimized?: boolean }>`
  position: fixed;
  bottom: 15px;
  right: 30px;
  display: flex;
  flex-direction: column-reverse;
  gap: 20px;
  z-index: 2000;
  transition: all 0.3s ease;

  /* Quando minimizado, esconder elementos específicos */
  ${({ minimized }) =>
    minimized &&
    `
    .call-list-container {
      display: none !important;
      opacity: 0;
      height: 0;
      overflow: hidden;
    }
  `}
`;

export const StatusCard = styled.div`
  width: 350px;
  height: 64px;
  border: 1.5px solid #1d52a5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
`;

export const StatusContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StatusInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusIcon = styled.div`
  width: 40px;
  height: 40px;
  background: #d2ddef;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StatusText = styled.div`
  font-size: 14px;
  font-weight: bold;
`;

export const CallListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
  transition: all 0.3s ease;

  /* Adicionar classe para controle via CSS */
  &.call-list-container {
    transition: all 0.3s ease;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const DealLink = styled.a`
  line-height: 19px;
  color: #07b2fd;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const CallActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CallInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CallUserName = styled.div`
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
`;

export const CallDealContainer = styled.div`
  display: flex;
`;

// Estilos para animação de pulse
export const PulseAnimation = `
  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
`;
